module.exports = __webpack_public_path__ + "img/ICN.0bdec930.svg";